import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class OrdersService {
  fetchStoreOrders(data) {
    console.log("Service data", data.page);
    return axios.post(API_URL + "orders/fetch", data, {
      headers: authHeader(),
    });
  }

  bulkUpdateOrderAndItems(data) {
    return axios.post(API_URL + "orders/bulk-update", data, {
      headers: authHeader(),
    });
  }
  singleValueUpdateOrderAndItems(data) {
    return axios.post(API_URL + "orders/single-value-update", data, {
      headers: authHeader(),
    });
  }
  getLogs(orderId) {
    return axios.get(API_URL + `orders/get-logs/${orderId}`, {
      headers: authHeader(),
    });
  }
  fetchCustomerOrdersHistory(orderId) {
    return axios.get(
      `${API_URL}orders/fetch-customer-orders-history/${orderId}`,
      {
        headers: authHeader(),
      }
    );
  }

  renameAndDownloadFile(data) {
    return axios.post(`${API_URL}orders/rename-and-download-file`, data, {
      headers: authHeader(),
    });
  }

  refetchOrderFromShopify(id, shopifyId, storeId) {
    let data = {
      id,
      shopifyId,
      storeId,
    };
    return axios.post(`${API_URL}orders/refetch-order-record`, data, {
      headers: authHeader(),
    });
  }

  fetchOrderEvents(orderPk) {
    return axios.get(`${API_URL}order-events/get-list/${orderPk}`, {
      headers: authHeader(),
    });
  }
}

export default new OrdersService();
